import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { canSeeApp } from '../../core/auth/auth.selectors'
import { DefaultRouteService } from '../private-layout/default-route.service'

@Injectable({ providedIn: 'root' })
export class AppLayoutGuard {
  constructor(private store: Store, private router: Router, private defaultRoute: DefaultRouteService) {}

  canActivate(route: ActivatedRouteSnapshot): false | Observable<boolean> {
    const appId: string = route.params.appId
    if (!appId) {
      this.router.navigateByUrl('/apps')
      return false
    }
    return this.store.pipe(
      canSeeApp(appId),
      tap((res) => {
        if (res) this.defaultRoute.saveDefaultApp(appId)
        else this.router.navigateByUrl('/auth/login')
      })
    )
  }
}
